var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLaunchpack)?[(_vm.isAdmin)?_c('superadmin-dashboard'):_c('superadmin-partner-dashboard')]:_c('dashboard')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }